import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from 'react-router-dom'

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import App from "./App";
import { installSessionGuard } from './utils/sessionGuard';
import './style/index.scss';

// Installed before the app renders so an expired session is caught on the very first API call
// instead of surfacing the raw "Unauthorized - No token provided" from the server.
installSessionGuard();

window.addEventListener('load', (e) => {
  const targetElement = document.getElementById('root');
  if (targetElement) {
    const root = createRoot(targetElement);
    root.render(
      <App />
    );
  }
});